import { ElementAttribute } from "./ElementAttribute";

export class TabSelector
{
  static readonly selector = "TAB-SELECTOR";
  static readonly tabSelector = new ElementAttribute( "tab" );
  static readonly activeSelector = new ElementAttribute( "active" );
  static readonly displayAttribute = new ElementAttribute( "display" );
  
  static applyOnDocument( selector = TabSelector.selector)
  {
    let elements = document.querySelectorAll( selector );

    for ( let i = 0; i < elements.length; i++ )
    {
      TabSelector.applyOnElement( elements[ i ] );
    }
  }

  static applyOnElement( element:Element )
  {
    let tabs = TabSelector.tabSelector.queryValueAllIn( element ) as HTMLElement[];
    let displayValue = this.displayAttribute.from( element ) || "block";

    tabs.forEach( t =>
    {
      t.addEventListener( "click", e =>
      {           
        let activeElement = TabSelector.activeSelector.queryValueInDoc( t );
        console.log( "active", activeElement )

        tabs.forEach( tab =>
        { 
          let target = TabSelector.activeSelector.queryValueInDoc( tab ) as HTMLElement;
          let assigningValue = activeElement === target ? displayValue : "none";

          console.log( "TAB", tab, "TARGET:", target, "VALUE:", assigningValue );
          target.style.display = assigningValue;
        });

      });
        
    });

    tabs[ 0 ].click();
  }
}